module.exports = __webpack_public_path__ + "static/img/border2.f6d9b16.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/feature/border2.jpg
// module id = crh9
// module chunks = 7